/**
 * @category LeftSide
 * @component
 * @module Files/fileProcessing/FileList
 * @description This component is responsible for creating a file list and marking which file is selected from
 * the list.
 */
import React from "react";
import DoneIcon from "@mui/icons-material/Done";
import "./fileProcessing.scss";
import { checkIfSolved } from "./processingLogic";

function FileList(props) {
  const { selectedFileIndex, filesToProcess, setSelectedFile } = props;

  return (
    <div className="fileList">
      {filesToProcess.map((file, index) => {
        const isSolved = checkIfSolved(file);
        return (
          <div
            key={index}
            className={`fileEntry ${
              index === selectedFileIndex ? "selected" : ""
            } ${isSolved ? "solved" : ""}`}
            onClick={isSolved ? undefined : () => setSelectedFile(index)}
            style={isSolved ? { cursor: "not-allowed" } : { cursor: "pointer" }}
          >
            <div className="fileName">{file.name}</div>
            {isSolved ? <DoneIcon className="icon" /> : <></>}
          </div>
        );
      })}
    </div>
  );
}

export default FileList;
